export interface CachedData<T> {
  data: T;
  timestamp: number;
}

function isStale(timestamp: number, ttl: number): boolean {
  return Date.now() - timestamp > ttl;
}

export function getCachedData<T>(key: string, ttl: number): T | false {
  const cache = localStorage.getItem(key);

  if (!cache) {
    return false;
  }

  const {data, timestamp} = JSON.parse(cache);

  if (isStale(timestamp, ttl)) {
    return false;
  }

  return data;
}

export function setCacheData<T>(key: string, data: T): CachedData<T> | false {
  if (!key) {
    return false;
  }

  const timestamp = Date.now();
  const cachedData = {data, timestamp};

  localStorage.setItem(key, JSON.stringify(cachedData));

  return cachedData;
}
